globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.OptimizeSubject = (function(superClass) {

  utils.extend(OptimizeSubject, superClass);

  function OptimizeSubject() {
    return OptimizeSubject.__super__.constructor.apply(this, arguments);
  }

  $.extend(OptimizeSubject.prototype, {
    init: function() {
      appCustomerSpace.LimitlessPlugins.initPlugins(this.$html);
      this._bindFormSubmit();
      this._startLoader();
      this._fetchSuggestions();

      return OptimizeSubject.__super__.init.apply(this, arguments);
    },

    _$loaderContainer: function() {
      return this.$html.find(".js-optimize-subject-suggestions-wrapper");
    },

    _startLoader: function() {
      appCustomerSpace.Loader().start({
        $container: this._$loaderContainer(),
        options: {
          text: "Jacques rédige 3 propositions…",
          icon_size: "3x",
          style: { backdrop: { background: "rgba(239, 245, 254, 0.7)" } }
        }
      });
    },

    _stopLoader: function() {
      appCustomerSpace.Loader().stop({ $container: this._$loaderContainer() });
    },

    _fetchSuggestions: function() {
      var modal = this;
      var url = modal.$html.data("optimize-url");

      $.ajax({
        url: url,
        method: "POST",
        success: function(data) {
          if (data.response == 1 && data.subjects && data.subjects.length) {
            modal._renderSuggestions(data.subjects);
          } else {
            modal._handleFailure((data.errors || []).join(", "));
          }
        },
        error: function() {
          modal._handleFailure("Erreur lors de la génération des objets.");
        }
      });
    },

    _renderSuggestions: function(subjects) {
      var $texts = this.$html.find(".js-suggestion-text");
      $texts.each(function(index) {
        $(this).text(subjects[index] || "");
      });
      this._stopLoader();
      this.$html.find(".js-optimize-subject-suggestions").show();
      this.$html.find(".js-optimize-subject-submit").prop("disabled", false);
    },

    _handleFailure: function(message) {
      this._stopLoader();
      this.close();
      new PNotify({ icon: "icon-cross2", title: message || "Erreur lors de la génération.", type: "error" });
    },

    _bindFormSubmit: function() {
      var modal = this;
      modal.$html.find("form").on("submit", function() {
        var selectedIndex = parseInt(modal.$html.find('input[name="selected_index"]:checked').val(), 10);
        var selectedSubject = modal.$html.find(".js-suggestion-text").eq(selectedIndex).text();
        modal.$html.find('input[name="subject"]').val(selectedSubject);
      });
    },

    callbackSuccess: function(data) {
      if (data.response == 1 && data.subject) {
        var $subjectInput = $("#newsletter-subject-input");
        if ($subjectInput.length) {
          $subjectInput.val(data.subject).trigger("change").trigger("input");
        }
        new PNotify({ icon: "icon-checkmark3", title: "Objet mis à jour", type: "success" });
      } else {
        new PNotify({ icon: "icon-cross2", title: "Erreur lors de la mise à jour de l'objet.", type: "error" });
      }

      return OptimizeSubject.__super__.callbackSuccess.apply(this, arguments);
    }
  });

  return OptimizeSubject;

})(appCustomerSpace.Modal);
